import i18n from 'helper/i18n';

import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';

export const FILTER_ID = 'RECIPE_DURATION' as const;

export const FILTER_FACTORY = {
	BELOW_30: (item: ContentTypePoolRecipeDtoType) => item.totalDuration <= 1800,
	BELOW_60: (item: ContentTypePoolRecipeDtoType) => item.totalDuration <= 3600,
	ABOVE_60: (item: ContentTypePoolRecipeDtoType) => item.totalDuration > 3600,
};

export const FILTER = {
	BELOW_30: 'BELOW_30',
	BELOW_60: 'BELOW_60',
	ABOVE_60: 'ABOVE_60',
} as const;

export const FILTER_LABELS: { [key: string]: React.ReactNode } = {
	BELOW_30: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.BELOW_30}`),
	BELOW_60: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.BELOW_60}`),
	ABOVE_60: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.ABOVE_60}`),
};

export function filterForDuration(filter: (keyof typeof FILTER)[]): (item: ContentTypePoolRecipeDtoType) => boolean {
	return (item: ContentTypePoolRecipeDtoType) => {
		return FILTER_FACTORY[filter[0]](item);
	};
}

export default filterForDuration;
